import React from "react";
import styles from "./HomeHero.module.css";
import heroBg from "../assets/hero-crowd.jpg";
import { useTranslation } from 'react-i18next';

const HomeHero = () => {
  const { t } = useTranslation('homeHero');
  return (
    <section className={styles.hero}>
      <div
        className={styles.bg}
        style={{ backgroundImage: `url(${heroBg})` }}
        aria-hidden="true"
      />
      <div className={styles.overlay} />

      <div className={styles.inner}>
        <h1 className={styles.title}>{t('title')}</h1>

        <div className={styles.choiceGrid}>
<a className={`${styles.choiceCard} ${styles.choiceLeft}`} href="/events">
  <div className={styles.choiceIcon}>
    <img src="/icons/MusicalNote.svg" alt={t('noteAlt')} className={styles.choiceIconImage} />
  </div>
  <div className={styles.choiceText}>{t('goToEvent')}</div>
</a>

<a className={`${styles.choiceCard} ${styles.choiceRight}`} href="/organizer">
  <div className={styles.choiceIcon}>
    <img src="/icons/Megaphone.svg" alt={t('megaphoneAlt')} className={styles.choiceIconImage} />
  </div>
  <div className={styles.choiceText}>{t('hostEvent')}</div>
</a>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
